import React, { useState } from "react";
import Td from "./td";
import Th from "./th";
import ButtonTable from "./buttonTable";
import Button from "../button/button";
import "./newTr.css";
import { useEffect } from "react";

export default (props) => {
    const [loading, setLoading] = useState(!!props.delay);
    const [isHovered, setHovered] = useState(false);

    useEffect(() => {
        if (!props.delay) {
            setLoading(false);
            return;
        }

        setLoading(true);

        const t = setTimeout(() => {
            setLoading(false);
        }, props.delay);

        return () => {
            clearTimeout(t);
        };
    }, [props.delay]);

    const estilos = {
        backgroundColor: props.backgroundColorTr,
        filter:
            isHovered && props.botoes
                ? String(props.backgroundColorTr).toLocaleUpperCase() === "#FFFFFF" || String(props.backgroundColorTr).toLocaleUpperCase() === "rgb(255, 255, 255)"
                    ? "brightness(0.95)"
                    : "brightness(1.1)"
                : "",
        "--backgroundColorTd": props.backgroundColorTd || "",
        "--backgroundColorTr": props.backgroundColorTr || "",
    };

    //remove os nulos
    const botoes = props.botoes ? props.botoes.filter((item) => !!item) : [];
    const botoesIcone = botoes.filter((botao) => botao.icon || (botao.children && botao.event)); //quando usa mais de um ícone passa o elemento na prop children
    const botoesTexto = botoes.filter((botao) => !botao.icon && !botao.children); //se n tem icone nem childen é botao de texto.Ex: 'Importar'
    const spans = botoes.filter((item) => !item.event && !item.icon);

    //agrupa botoes em pares para cada par ficar abaixo do outro
    const paresBotoesComIcone = [];
    let par = [];
    for (let i = 0; i < botoesIcone.length; i++) {
        if (par.length < 2) {
            par.push(botoesIcone[i]);
        }
        if (par.length == 2) {
            paresBotoesComIcone.push(par);
            par = [];
        }
    }

    if (loading) {
        return (
            <tr>
                <td style={{ height: props.delayHeightRow }} colSpan={props.children.length + 1}>
                    CARREGANDO...
                </td>
            </tr>
        );
    }
    return (
        <tr
            className={`linha-cores-intercaladas ${props.highlightAlert ? "animacao-alerta" : ""}`}
            style={{ ...props.style, ...estilos }}
            onMouseEnter={() => setHovered(true)}
            onClick={() => {
                setHovered(!isHovered);
                if (props.event) {
                    props.event();
                }
            }}
            onMouseLeave={() => setHovered(false)}
        >
            {props.children}
            {props.noButtons ? null : props.botoes ? (
                <Td backgroundColor={props.backgroundColorTr} minWidth={botoes.length ? 100 : null}>
                    {/* RENDERIZA AS MENSAGENS no lugar dos botoes. Ex: 'Fatura isenta' */}
                    {isHovered ? spans.map((span, i) => <div key={i}>{span.children}</div>) : null}
                    {/* RENDERIZA OS BOTÕES DE TEXTO */}
                    {botoesTexto.length ? (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: props.botoesDirectionRow ? "row" : "column",
                                alignItems: "center",
                                justifyContent: "end",
                                minWidth: "100%",
                                marginBottom: 2,
                                visibility: isHovered ? "visible" : "hidden",
                            }}
                        >
                            {botoesTexto.map((botao, i) => (
                                <Button key={i} {...botao} />
                            ))}
                        </div>
                    ) : null}
                    {/* RENDERIZA BOTOES PEQUENOS COM ICONE, ATÈ 3 em linha, 4 ou mais mostra pares um abaixo do outro */}
                    {botoesIcone.length < 4 ? (
                        <div
                            style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "end",
                            }}
                        >
                            {botoesIcone.map((botao, i) => (
                                <ButtonTable key={i} {...botao} visible={isHovered} />
                            ))}
                        </div>
                    ) : (
                        paresBotoesComIcone.map((par, i) => (
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    minWidth: "100%",
                                    justifyContent: "end",
                                }}
                            >
                                {par.map((botao, j) => (
                                    <ButtonTable key={j} {...botao} visible={isHovered} />
                                ))}
                            </div>
                        ))
                    )}
                </Td>
            ) : (
                <Th backgroundColor={props.backgroundColorTr} rowSpan={props.rowSpanBotoes} sticky style={{ fontSize: "0.85rem" }} alignCenter></Th>
            )}
        </tr>
    );
};
